import MicroModal from 'micromodal';

// Module Life
import './general';
import { focusTrap } from './global/focus-trap';
import './components/hero-feature';

focusTrap();
MicroModal.init();
